const pojoize = _store => next => action => next(Object.assign({}, action));
export default pojoize;
